const UNIT_TYPE_LOCALIZATION_COMPONENT_NAME = 'MOBILE';

export default UNIT_TYPE_LOCALIZATION_COMPONENT_NAME;
